document.addEventListener('DOMContentLoaded', function() {
  
  // Animate on scroll
  const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('fade-in');
      }
    });
  }, observerOptions);
  
  document.querySelectorAll('.fade-in').forEach(el => {
    observer.observe(el);
  });
  
  // Cart notification
  document.querySelectorAll('.add-to-cart-form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData)
      })
      .then(response => response.json())
      .then(data => {
        // Update cart count
        updateCartCount();
        showNotification('Product added to cart!');
      });
    });
  });
  
  // Update cart count
  function updateCartCount() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        document.getElementById('cart-count').textContent = cart.item_count;
      });
  }
  
  // Notification toast
  function showNotification(message) {
    const toast = document.createElement('div');
    toast.className = 'fixed top-4 right-4 bg-primary text-white px-6 py-3 rounded-lg shadow-lg z-50';
    toast.textContent = message;
    document.body.appendChild(toast);
    
    setTimeout(() => {
      toast.remove();
    }, 3000);
  }
  
  // Variant selection
  document.querySelectorAll('.variant-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      document.querySelectorAll('.variant-btn').forEach(b => {
        b.classList.remove('border-primary', 'bg-primary', 'text-white');
      });
      this.classList.add('border-primary', 'bg-primary', 'text-white');
      document.querySelector('input[name="id"]').value = this.dataset.variantId;
    });
  });
  
  // Search functionality
  const searchBtn = document.querySelector('a[href="/search"]');
  searchBtn.addEventListener('click', function(e) {
    e.preventDefault();
    // Implement search modal
  });
  
});